export default function newApprovalDenied() {
    return {
        type: newApprovalDenied.type,
    };
}

newApprovalDenied.type = 'NEW_APPROVAL_DENIED';
